import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { EditIcon, Delete02Icon, PlusIcon } from '../../../../../assets/icons';
import ContactPurposeModal from '../../../../../components/modals/UserProfile/ContactPurposeModal';
import DeletePopup from '../../../../../components/delete-popup';
import { addUserContactPurpose, updateUserContactPurpose, deleteUserContactPurpose } from '../../../../../redux/slice/allUsersSlice';
import { useToast } from '../../../../../context/TostContext';
import { IconBtn } from '../../../../../components/commonButton/btns';

const ContactPurposes = ({ userDetail }) => {
    const {id} = useParams();
    const dispatch = useDispatch();
    const toast = useToast();
    const [showModal, setShowModal] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const contactPurposes = userDetail?.contact_purposes || [];

    const handleUpsertContactPurpose = (data) => {
        setIsLoading(true);
        const action = currentItem
            ? updateUserContactPurpose({ id: id, purposeId: currentItem.id, data })
            : addUserContactPurpose({ id: id, data });

        dispatch(action)
            .unwrap()
            .then(() => {
                toast.success(`Contact purpose ${currentItem ? "updated" : "added"} successfully`);
                setShowModal(false);
                setCurrentItem(null);
            })
            .catch((error) => {
                toast.error(error?.message || `Failed to ${currentItem ? "update" : "add"} contact purpose`);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleDeleteContactPurpose = () => {
        setIsLoading(true);
        dispatch(deleteUserContactPurpose({ id: id, purposeId: itemToDelete }))
            .unwrap()
            .then(() => {
                toast.success("Contact purpose deleted successfully");
                setShowDeletePopup(false);
                setItemToDelete(null);
            })
            .catch((error) => {
                toast.error(error?.message || "Failed to delete contact purpose");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <div className="position-relative h-100">
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h6 className="fw-bold mb-0" style={{ fontSize: '18px' }}>Contact Purposes</h6>
                <IconBtn size={32} icon={<PlusIcon size={16} />} className='rounded-circle' onClick={() => {
                    setCurrentItem(null);
                    setShowModal(true);
                }} />
            </div>


            {contactPurposes.length > 0 ? (
                <div className="bg-white rounded-3 overflow-hidden shadow-sm p-4">
                    <div className="d-flex flex-wrap gap-2">
                        {contactPurposes.map((purpose, index) => (
                            <span
                                key={purpose.id || index}
                                className="badge bg-light text-dark border px-3 py-2 rounded-pill fs-6 fw-normal shadow-sm d-flex align-items-center gap-2"
                            >
                                {purpose.title}
                                <div className="d-flex align-items-center gap-1 border-start ps-2 ms-1">
                                    <button
                                        className="btn btn-link p-0 text-primary"
                                        onClick={() => {
                                            setCurrentItem(purpose);
                                            setShowModal(true);
                                        }}
                                        title="Edit"
                                    >
                                        <EditIcon width={12} height={12} />
                                    </button>
                                    <button
                                        className="btn btn-link p-0 text-danger"
                                        onClick={() => {
                                            setItemToDelete(purpose.id);
                                            setShowDeletePopup(true);
                                        }}
                                        title="Delete"
                                    >
                                        <Delete02Icon size={12} />
                                    </button>
                                </div>
                            </span>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="text-center py-5 text-muted">
                    <p className="mb-0">No contact purposes listed.</p>
                </div>
            )}


            <ContactPurposeModal
                isOpen={showModal}
                onClose={() => setShowModal(false)}
                onSubmit={handleUpsertContactPurpose}
                purpose={currentItem}
                isLoading={isLoading}
                title={currentItem ? "Edit Contact Purpose" : "Add Contact Purpose"}
                size="md"
            />

            {showDeletePopup && (
                <DeletePopup
                    show={showDeletePopup}
                    onHide={() => setShowDeletePopup(false)}
                    onConfirm={handleDeleteContactPurpose}
                    disabled={isLoading}
                    title="Delete Contact Purpose"
                    content="Are you sure you want to delete this contact purpose?"
                    saveTitle="Delete"
                />
            )}
        </div>
    );
};

export default ContactPurposes;
